import { useQuery } from 'react-query';
import { getPropertyInfo } from 'services/affordableService';
import useAbortController from 'hooks/useAbortController';
import { useContext } from 'react';
import { AppContext } from 'contexts/AppContext';

const usePropertyInfoQuery = ({ options } = {}) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const abortControllerOptions = useAbortController();
  const queryKey = ['getPropertyInfo', organizationId, propertyId];

  return useQuery(
    queryKey,
    () => getPropertyInfo(organizationId, propertyId, abortControllerOptions),
    {
      enabled: !!organizationId && !!propertyId,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnSettled: false,
      retry: false,
      ...options,
    },
  );
};

export default usePropertyInfoQuery;
